import styled from "styled-components";


export const StyledAddCollectionMethodModalContent = styled.div`
  .form {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .form-field {
      display: flex;
      flex-direction: column;
    }

    .form-actions {
      margin-top: 1rem;
      display: flex;
      gap: 0.5rem;
    }
  }
`;
